import { call, put } from 'redux-saga/effects';

import {
  setFriendActivityAction,
  setFriendBadgesAction,
  setFriendHeaderAction,
  setFriendProfileAction,
  setFriendScoringHistoryAction,
  setFriendStatsAction,
} from '../actions/friendProfileActions';
import Services from '../services';

// for fiend stats component
export function* getFriendStats(action) {
  try {
    yield put(setFriendStatsAction({}));
    const response = yield call(Services.FriendProfileService.getFriendStats);
    yield put(setFriendStatsAction(response));
  } catch (exception) {}
}

// for friend Activity
export function* getFriendActivity(action) {
  try {
    yield put(setFriendActivityAction({}));
    const response = yield call(
      Services.FriendProfileService.getFriendActivity,
      action.timePeriod,
    );
    yield put(setFriendActivityAction(response));
  } catch (exception) {}
}

// for friend badges
export function* getFriendBadgesSagas(action) {
  try {
    const response = yield call(
      Services.FriendProfileService.getFriendBadgesService,
      action.skip,
      action.limit,
    );
    yield put(setFriendBadgesAction(response));
  } catch (exception) {}
}

// for friend scoring history

export function* getFriendScoringHistorySagas(action) {
  try {
    const response = yield call(
      Services.FriendProfileService.getFriendScoringHistoryService,
      action.timePeriod,
    );
    yield put(setFriendScoringHistoryAction(response));
  } catch (exception) {}
}

// for friend profile
export function* getFriendProfileSagas(action) {
  try {
    const response = yield call(
      Services.FriendProfileService.getFriendProfileService,
    );
    yield put(setFriendProfileAction(response));
  } catch (exception) {}
}

// for friend Header
export function* getFriendHeaderSagas(action) {
  try {
    const response = yield call(
      Services.FriendProfileService.getFriendHeaderService,
    );
    yield put(setFriendHeaderAction(response));
  } catch (exception) {}
}
